import { createTheme } from '@mui/material/styles';

const lightTheme = {
	typography: {
		fontFamily: ['Montserrat', 'Ubuntu', 'Karla'].join(',')
	},
	palette: {
		type: 'light',
		common: {
			black: '#000000',
			white: '#ffffff',
			offWhite: '#B0B0B0'
		},
		primary: {
			main: '#EAB457'
		},
		accessibilityBtn: {
			main: '#005abb',
			secondary: '#007BFF'
		},
		secondary: {
			main: '#0A0A37'
		}
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					margin: '8px'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				variant: 'contained'
			},
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.primary.contrastText
				})
			}
		}
	}
};

export default createTheme(lightTheme);
